import { useEffect, useState } from "react";
import { listSavings, type SavingsRow } from "../api";

export function Savings() {
  const [rows, setRows] = useState<SavingsRow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    listSavings()
      .then(r => setRows(r.savings))
      .catch(e => setErr(e instanceof Error ? e.message : "load failed"));
  }, []);

  if (err) return <div className="err">{err}</div>;
  if (!rows) return <div>Loading savings…</div>;

  const totalMonthly = rows.reduce((s, r) => s + r.estimated_monthly_saving_aud, 0);
  const totalAnnual  = rows.reduce((s, r) => s + r.estimated_annual_saving_aud,  0);
  const totalBytes   = rows.reduce((s, r) => s + r.total_bytes_archived, 0);

  return (
    <>
      <h2>Savings</h2>
      <div className="row" style={{ gap: "1rem", marginBottom: "1rem" }}>
        <Stat label="Monthly (AUD)" value={`$${totalMonthly.toFixed(2)}`} />
        <Stat label="Annual (AUD)"  value={`$${totalAnnual.toFixed(2)}`} />
        <Stat label="Bytes archived" value={fmtBytes(totalBytes)} />
        <Stat label="Tenants" value={String(rows.length)} />
      </div>
      <table>
        <thead>
          <tr>
            <th>Tenant</th>
            <th>Files</th>
            <th>Bytes</th>
            <th>Monthly (AUD)</th>
            <th>Annual (AUD)</th>
            <th>Last recomputed</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.tenant_id}>
              <td>{r.display_name}</td>
              <td>{r.total_files_archived.toLocaleString()}</td>
              <td>{fmtBytes(r.total_bytes_archived)}</td>
              <td>${r.estimated_monthly_saving_aud.toFixed(2)}</td>
              <td>${r.estimated_annual_saving_aud.toFixed(2)}</td>
              <td className="mono">{shortTs(r.last_recomputed_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ background: "#fff", border: "1px solid #dde3ea", borderRadius: 8, padding: "1rem 1.25rem", minWidth: 160 }}>
      <div className="muted" style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: ".05em" }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 600 }}>{value}</div>
    </div>
  );
}

function shortTs(s: string): string { return s.replace("T", " ").replace("Z", "").slice(0, 19); }
function fmtBytes(n: number): string {
  if (!n) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"]; let i = 0; let v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return v.toFixed(v >= 100 ? 0 : 1) + " " + units[i];
}
